<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[2].header | translate"
        [subtitle]="steps[2].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="2" />
    </div>
  </soft-page-header>

  <div class="soft-overline mt-4 mb-1">
    {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.MENGE' | translate}}
  </div>

  @if (artikel$ | async; as artikel) {
  <soft-stock-quantity-control
    #quantityControl
    class="mt-2 block"
    (quantityChange)="onMengeChange($event)"
    [product]="artikel.artikel"
    [unit]="artikel.einheit"
    [quantity]="artikel.menge"
    [artehEingabe]="artikel?.arteheingabe ?? false"
    [unitEntryId]="$safeNavigationMigration(artikel?.idarteheingabe)"
    [artehEingabeRequired]="artikel?.arteheingabePflicht ?? false"
  />
  }

  <soft-page-footer>
    <button
      type="button"
      class="soft-button primary w-full h-20"
      [disabled]="!canContinue()"
      (click)="onSubmit()"
    >
      {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.SUBMIT' | translate}}
    </button>
  </soft-page-footer>
</soft-page>
